// Night Service: dark and dense for busy service and kitchen screens. The default on
// KDS terminals. Item codes, the open-table strip and F-key tenders are on by default.
import { defineTheme } from './types.js';

export const nightService = defineTheme({
  id: 'night-service',
  name: 'Night Service',
  description: 'Dark and dense for rush hours and kitchen screens. Item codes and F-keys on.',
  look: {
    colorScheme: 'dark',
    colors: {
      bg: '#0d1117',
      surface: '#161b22',
      surfaceRaised: '#1c232c',
      surfaceSunken: '#090c10',
      border: '#2a313c',
      borderStrong: '#6e7887',
      text: '#e8edf3',
      textMuted: '#a5afbc',
      accent: '#f5a524',
      accentHover: '#f8b84e',
      onAccent: '#14100a',
      accentSoft: '#3a2b10',
      onAccentSoft: '#fbd69a',
      focus: '#79c0ff',
      success: '#3fb950',
      onSuccess: '#0b1a0f',
      warning: '#e3b341',
      onWarning: '#1a1405',
      danger: '#ff7b72',
      onDanger: '#2b0705',
      info: '#58a6ff',
      onInfo: '#07162b',
      veg: '#3fb950',
      nonVeg: '#ff7b72',
      overlay: '#000000b3',
      table: {
        free: { bg: '#12301b', fg: '#aff0bd' },
        occupied: { bg: '#3a2b10', fg: '#fbd69a' },
        billed: { bg: '#102a4c', fg: '#b6d6ff' },
        reserved: { bg: '#2c1d45', fg: '#dcc8fb' },
      },
      categories: [
        { bg: '#4a2b08', fg: '#ffd9a6' },
        { bg: '#12301b', fg: '#aff0bd' },
        { bg: '#102a4c', fg: '#b6d6ff' },
        { bg: '#46162a', fg: '#ffc2da' },
        { bg: '#2c1d45', fg: '#dcc8fb' },
        { bg: '#0f3532', fg: '#a8f0e8' },
        { bg: '#3b3006', fg: '#f5e49c' },
        { bg: '#2d333b', fg: '#e1e6ec' },
      ],
    },
    shadows: {
      sm: '0 1px 2px #00000080',
      md: '0 4px 12px #00000099',
      lg: '0 12px 32px #000000b3',
    },
  },
  typography: {
    fontSans:
      '"IBM Plex Sans", "Segoe UI", system-ui, -apple-system, "Noto Sans", Roboto, Arial, sans-serif',
    fontNumeric:
      '"IBM Plex Mono", "JetBrains Mono", ui-monospace, "Cascadia Mono", "Segoe UI Mono", Menlo, Consolas, monospace',
    sizes: {
      xs: '0.75rem',
      sm: '0.8125rem',
      md: '0.9375rem',
      lg: '1.0625rem',
      xl: '1.25rem',
      xxl: '1.5rem',
      display: '2rem',
    },
    lineHeight: 1.4,
    weights: { regular: 400, medium: 500, bold: 650 },
  },
  radii: { sm: '4px', md: '6px', lg: '10px', pill: '999px' },
  space: 4,
  touchMin: 44,
  features: {
    itemCodeEntry: true,
    tableStrip: true,
    categoryColours: false,
    density: 'compact',
    keyboardShortcuts: true,
  },
});
